<template>
  <div class="modal" v-show="isshow">
    <div class="ztx-modal"/>
    <div class="ztx-message-box">
      <div class="ztx-message-main">
        <div class="ztx-message-tit">
          <span>{{modalTitle}}</span>
          <div @click.self="closeModal" class="ztx-message-close">×</div>
        </div>
        <div class="ztx-messge-content">
          <slot name="modal-content"/>
        </div>
        <div class="ztx-message-btngroup">
          <slot name="modal-footer">
            <button class="ztx-message-btn ztx-message-canbtn" @click="cancelHander">{{cancelButtonText}}</button>
            <button class="ztx-message-btn ztx-message-okbtn" @click="conformHander">{{confirmButtonText}}</button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      modalTitle: {
        type: String,
        default: '确认'
      },
      cancelButtonText: {
        type: String,
        default: '取消'
      },
      confirmButtonText: {
        type: String,
        default: '确认'
      }
    },
    data() {
      return {
        isshow: false
      }
    },
    computed: {},
    watch: {
      show(newval) {
        this.isshow = newval;
        // if (newval) {
        //   this.isshow = true;
        // }
      }
    },
    methods: {
      closeModal() {
        this.cancelHander();
      },
      conformHander() {
        this.$emit("conformHander");
        // this.isshow = false;
      },
      cancelHander() {
        this.$emit("cancelHander");
        this.isshow = false;
      }
    }
  };
</script>

<style lang="less" scoped>
  @import url('../assets/css/public.less');
</style>



// WEBPACK FOOTER //
// Modal.vue?3faa7448